"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const WinterTiresLabelView_1 = __importDefault(require("@react/web/Listing/ListingOffersList/CarListingItem/views/WinterTiresLabelView"));
const AvailabilityLabelView_1 = __importDefault(require("@react/web/Listing/ListingOffersList/CarListingItem/views/AvailabilityLabelView"));
const OfferLabelsView = ({ simpleOffer, }) => react_1.default.createElement("div", { className: "labels" },
    simpleOffer.offerLabelList.length > 0
        && simpleOffer.offerLabelList.map((label) => react_1.default.createElement("div", { key: label, className: "label" }, label)),
    simpleOffer.hasWinterTires && react_1.default.createElement(WinterTiresLabelView_1.default, null),
    simpleOffer.availabilityDescription && react_1.default.createElement(AvailabilityLabelView_1.default, { description: simpleOffer.availabilityDescription }));
exports.default = OfferLabelsView;
